<template>
  <div id="member">
    <router-view />
  </div>
</template>

<script>
export default {};
</script>

<style>
#member{
  height: 100%;
}
</style>